import { Component } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { fadeIn, fadeInOut } from 'src/app/animations';
import { AdesaoSaudeEnum } from 'src/app/shared/enum/adesao-saude-enum';
import { UfEnum } from 'src/app/shared/enum/uf';
import { ModalAvisoMaior24Component } from 'src/app/shared/modals/modal-aviao-maior24/modal-aviao-maior24.component';
import { ModalAvisoAdesaoComponent } from 'src/app/shared/modals/modal-aviso-adesao/modal-aviso-adesao.component';
import { ModalAvisoCompanheiroComponent } from 'src/app/shared/modals/modal-aviso-companheiro/modal-aviso-companheiro.component';
import { ModalFilhosEnteadosComponent } from 'src/app/shared/modals/modal-filhos-enteados/modal-filhos-enteados.component';
import { DataService } from 'src/app/shared/services/data.service';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { FormValidator } from 'src/app/shared/validators/Validator';
import { SolicitationService } from '../../../services/usuario/solicitation.service';
@Component({
  selector: 'app-adesao-plano-saude',
  templateUrl: './adesao-plano-saude.component.html',
  styleUrls: ['./adesao-plano-saude.component.css'],
  animations: [fadeIn, fadeInOut]
})
export class AdesaoPlanoSaudeComponent {
  enderecoResponsavel: any = null;
  faSquareXmark = faSquareXmark;
  formModal: any = null;
  dataQuestionario: any = null;
  showForm: boolean = false;
  exceededMaxFileSize: boolean = false;
  exceededMaxFileSizeProcedure: boolean = false;
  today = new Date();
  loading: boolean = false;
  actualUser: any;
  listaVinculoDependencia: any;
  mensagemData: string = '';
  ufOptions: any[] = [];
  listaCidades: any[] = [];
  formData = this.formBuilder.group({
    adesaoId: new FormControl(null, [Validators.required]),
    aceites: this.aceiteFilhoEnteado(false),
    certidaoCasamento: this.criarDocumentoCertidaoCasamento(false),
    certidaoNascimento: this.criarDocumentoCertidaoNascimento(false),
    cpfOuCnh: this.criarDocumentoCpf(false),
    dadosBancarios: this.criarDocumentoBancario(false),
    dadosDependente: this.createDependente(false),
    declaracaoVidaConjunta: this.createDeclaracaoVidaConjunta(false),
    documentoResponsavelLegal: this.criarDocumentoResponsavelLegal(false),
    endereco: this.formBuilder.group({
      rua: new FormControl(null, [Validators.required]),
      bairro: new FormControl(null, [Validators.required]),
      complemento: new FormControl(null),
      cidade: new FormControl(null, [Validators.required]),
      uf: new FormControl(null, [Validators.required]),
      numero: new FormControl(null, [Validators.required]),
      cep: new FormControl(null, [Validators.required, FormValidator.ValidaCep])
    }),
    enderecoTitular: new FormControl(false),
    rg: this.criarDocumentoRg(false),
    termoGuardaTutela: this.criarTermoGuardaOuTutelaMenor(false),
    termoConsentimento: this.criarTermoConsentimento(false),
    tipoPlano: new FormControl(''),
  });
  listaSexo: any = [
    { nome: 'Masculino', id: 1 },
    { nome: 'Feminino', id: 2 },
  ];
  listaAux: any = [
    { nome: 'Filho(a) maior', id: 1 },
    { nome: 'Filho(a) menor', id: 2 },
    { nome: 'Enteado(a) maior', id: 3 },
    { nome: 'Enteado(a) menor', id: 4 },
    { nome: 'Menor sob guarda 18 anos incompletos', id: 5 },
    { nome: 'Companheiro(a)', id: 6 },
    { nome: 'Cônjuge', id: 7 },
  ];
  listaTipoAdesao: any = [
    { nome: 'Filhos/Enteados até 24 anos incompletos', id: 1 },
    { nome: 'Filhos/Enteados com idade entre 24 e 39 anos incompletos', id: 2 },
    { nome: 'Menor sob guarda e tutelados até 18 anos incompletos', id: 3 },
    { nome: 'Companheiro (a)', id: 4 },
    { nome: 'Cônjuge', id: 5 }
  ];
  constructor(private userService: UsuarioService, private toast: ToastrService, private modalService: NgbModal, private formBuilder: FormBuilder,
    private tokenService: TokenService, private router: Router, private solicitationService: SolicitationService, private dataService: DataService) {
    this.actualUser = this.tokenService.getActiveUser();
    this.userService.getUser(this.actualUser.cpf).subscribe((res: any) => {
      this.enderecoResponsavel = res.contactResponse;
    });
    setTimeout(() => {
      this.formData.get('tipoPlano')?.setValue(this.actualUser.healthProfile.description);
    }, 300);
    this.ufOptions = Object.keys(UfEnum)
      .filter((key: any) => !isNaN(Number(UfEnum[key])))
      .map((key: any) => ({
        label: UfEnum[key],
        value: key,
      }));
  }
  enderecoTitular() {
    setTimeout(() => {
      if (this.formData.value.enderecoTitular == true) {
        this.formData.get('endereco.rua')?.setValue(this.enderecoResponsavel.address);
        this.formData.get('endereco.bairro')?.setValue(this.enderecoResponsavel.district);
        this.formData.get('endereco.complemento')?.setValue(this.enderecoResponsavel.complement);
        this.formData.get('endereco.cidade')?.setValue(this.enderecoResponsavel.city);
        this.formData.get('endereco.uf')?.setValue(this.enderecoResponsavel.state);
        this.formData.get('endereco.numero')?.setValue(this.enderecoResponsavel.number);
        this.formData.get('endereco.cep')?.setValue(this.enderecoResponsavel.cep);
      }
    }, 300)
  }
  cepChanged(event: any) {
    let cep: any = '';
    this.formData.get('endereco.cep')?.value
    cep = this.formData.controls.endereco.controls.cep.value;
    if (cep != null && cep.length == 8) {
      this.solicitationService.getZipCodeParams(this.formData.get('endereco.cep')?.value).subscribe({
        next: (res: any) => {
          if (res.bairro != null) {
            this.formData.get('endereco.uf')?.setValue(res.uf);
            this.formData.get('endereco.rua')?.setValue(res.logradouro);
            this.formData.get('endereco.bairro')?.setValue(res.bairro);
            this.formData.get('endereco.cidade')?.setValue(res.localidade);
            this.formData.controls.endereco.disable();
            this.formData.controls.endereco.controls.cep.enable();
            this.formData.controls.endereco.controls.complemento.enable();
            this.formData.controls.endereco.controls.numero.enable();
            this.formData.controls.endereco.updateValueAndValidity();
          } else {
            this.toast.warning('O CEP informado não foi localizado na base de dados do IBGE!');
          }
        },
        error: (err: any) => { }
      });
    } else {
      this.formData.controls.endereco.enable();
      this.formData.controls.endereco.updateValueAndValidity();
    }
  }
  accessionTypeChanged($event: any) { }
  accessionSelected($event: any) {
    this.initFormulario();
  }
  clearForm() {
    let form = this.formData.controls;
    this.showForm = false;
    form.certidaoNascimento.reset();
    form.aceites.reset();
    form.cpfOuCnh.reset();
    form.dadosDependente.reset();
    form.documentoResponsavelLegal.reset();
    form.rg.reset();
    form.termoGuardaTutela.reset();
    form.termoConsentimento.reset();
    form.declaracaoVidaConjunta.reset();
    form.certidaoNascimento = this.criarDocumentoCertidaoNascimento(false);
    form.cpfOuCnh = this.criarDocumentoCpf(false);
    form.rg = this.criarDocumentoRg(false);
    form.dadosDependente = this.createDependente(false);
    form.documentoResponsavelLegal = this.criarDocumentoResponsavelLegal(false);
    form.termoGuardaTutela = this.criarTermoGuardaOuTutelaMenor(false);
    form.termoConsentimento = this.criarTermoConsentimento(false);
    form.declaracaoVidaConjunta = this.createDeclaracaoVidaConjunta(false);
  }
  initFormulario() {
    this.showForm = false;
    this.listaVinculoDependencia = null;
    let modalRef = null;
    let id = this.formData.value.adesaoId ?? 0;
    this.clearForm();
    switch (id) {
      case AdesaoSaudeEnum.FILHOS_ENTEADOS_24ANOS_INCOMPLETOS:
        this.mensagemData = 'A idade do dependente deve ser de até 24 anos incompletos!';
        modalRef = this.modalService.open(ModalFilhosEnteadosComponent, { windowClass: 'carteirinha-modal-size', centered: true });
        modalRef.componentInstance.id = this.formData.value.adesaoId;
        this.listaVinculoDependencia = this.listaAux.filter((vinculo: any) => {
          return vinculo.id == 1 || vinculo.id == 3;
        });
        this.formData.controls.dadosDependente = this.createDependente(true);
        this.formData.controls.cpfOuCnh = this.criarDocumentoCpf(true);
        this.formData.controls.rg = this.criarDocumentoRg(true);
        this.formData.controls.aceites = this.aceiteFilhoEnteado(true);
        this.formData.get('dadosDependente.dataNascimento')?.setValidators([FormValidator.idadeMaximaValidator(24)]);
        this.formData.get('dadosDependente.dataNascimento')?.updateValueAndValidity();
        this.formData.updateValueAndValidity();
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
          this.formModal = res;
          this.formData.controls.termoConsentimento = (res.menorDoze == 'true') ? this.criarTermoConsentimento(true) : this.criarTermoConsentimento(false);
          this.formData.controls.certidaoNascimento = (res.menorDoze == 'true' || res.menorDezoito == 'true') ? this.criarDocumentoCertidaoNascimento(true) : this.criarDocumentoCertidaoNascimento(false);
          this.formData.controls.documentoResponsavelLegal = (res.menorDezoito == 'true' && res.responsavelJudicial == 'false') ? this.criarDocumentoResponsavelLegal(true) : this.criarDocumentoResponsavelLegal(false);
          this.listaVinculoDependencia = res.menorDezoito == 'false' ? this.listaAux.filter((vinculo: any) => {
            return vinculo.id == 1 || vinculo.id == 3;
          }) : this.listaAux.filter((vinculo: any) => {
            return vinculo.id == 2 || vinculo.id == 4;
          });
          if (res == null) {
            this.clearForm();
            this.formData.reset();
            return;
          }
          this.showForm = true;
          this.formData.updateValueAndValidity();
        });
        break;
      case AdesaoSaudeEnum.FILHOS_ENTEADOS_24ANOS_39ANOS_INCOMPLETOS:
        this.mensagemData = 'A idade do dependente deve ser de 24 anos completos até 39 anos incompletos!';
        modalRef = this.modalService.open(ModalAvisoMaior24Component, { windowClass: 'carteirinha-modal-size', centered: true });
        modalRef.componentInstance.id = this.formData.value.adesaoId;
        this.listaVinculoDependencia = this.listaAux.filter((vinculo: any) => {
          return vinculo.id == 1 || vinculo.id == 3;
        });
        this.formData.controls.dadosDependente = this.createDependente(true);
        this.formData.controls.cpfOuCnh = this.criarDocumentoCpf(true);
        this.formData.controls.rg = this.criarDocumentoRg(true);
        this.formData.controls.aceites = this.aceiteFilhoEnteado(true);
        this.formData.get('dadosDependente.dataNascimento')?.setValidators([FormValidator.idadeMaximaValidator(39), FormValidator.idadeMinimaValidator(24)]);
        this.formData.get('dadosDependente.dataNascimento')?.updateValueAndValidity();
        this.formData.updateValueAndValidity();
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
          this.showForm = true;
          this.formData.updateValueAndValidity();
        });
        break;
      case AdesaoSaudeEnum.MENOR_SOB_GUARDA:
        modalRef = this.modalService.open(ModalAvisoAdesaoComponent, { windowClass: 'carteirinha-modal-size', centered: true });
        modalRef.componentInstance.id = this.formData.value.adesaoId;
        this.listaVinculoDependencia = this.listaAux.filter((vinculo: any) => {
          return vinculo.id == 5;
        });
        this.formData.controls.certidaoNascimento = this.criarDocumentoCertidaoNascimento(true);
        this.formData.controls.aceites = this.aceiteFilhoEnteado(true);
        this.formData.controls.termoGuardaTutela = this.criarTermoGuardaOuTutelaMenor(true);
        this.formData.controls.cpfOuCnh = this.criarDocumentoCpf(true);
        this.formData.controls.rg = this.criarDocumentoRg(true);
        this.formData.controls.aceites = this.aceiteFilhoEnteado(true);
        this.formData.controls.dadosDependente = this.createDependente(true);
        this.formData.get('dadosDependente.dataNascimento')?.setValidators([FormValidator.idadeMaximaValidator(18)]);
        this.formData.get('dadosDependente.dataNascimento')?.updateValueAndValidity();
        this.formData.updateValueAndValidity();
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
          this.formData.controls.termoConsentimento = (res == 'true') ? this.criarTermoConsentimento(true) : this.criarTermoConsentimento(false);
          if (res == null) {
            this.clearForm();
            this.formData.reset();
            return;
          }
          this.formModal = res;
          this.showForm = true;
          this.formData.updateValueAndValidity();
        });
        break;
      case AdesaoSaudeEnum.COMPANHEIRO:
        this.formData.controls.cpfOuCnh = this.criarDocumentoCpf(true);
        this.formData.controls.rg = this.criarDocumentoRg(true);
        this.formData.controls.aceites = this.aceiteFilhoEnteado(true);
        this.formData.controls.dadosDependente = this.createDependente(true);
        this.formData.controls.declaracaoVidaConjunta = this.createDeclaracaoVidaConjunta(true);
        this.listaVinculoDependencia = this.listaAux.filter((vinculo: any) => {
          return vinculo.id == 6;
        });
        modalRef = this.modalService.open(ModalAvisoCompanheiroComponent, { windowClass: 'carteirinha-modal-size', centered: true });
        modalRef.componentInstance.id = this.formData.value.adesaoId;
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
          this.showForm = true;
          this.formData.updateValueAndValidity();
        });
        break;
      case AdesaoSaudeEnum.CONJUGE:
        this.listaVinculoDependencia = this.listaAux.filter((vinculo: any) => {
          return vinculo.id == 7;
        });
        this.formData.controls.cpfOuCnh = this.criarDocumentoCpf(true);
        this.formData.controls.rg = this.criarDocumentoRg(true);
        this.formData.controls.certidaoCasamento = this.criarDocumentoCertidaoCasamento(true);
        this.formData.controls.aceites = this.aceiteFilhoEnteado(true);
        this.formData.controls.dadosDependente = this.createDependente(true);
        modalRef = this.modalService.open(ModalAvisoCompanheiroComponent, { windowClass: 'carteirinha-modal-size', centered: true });
        modalRef.componentInstance.id = this.formData.value.adesaoId;
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
          this.showForm = true;
          this.formData.updateValueAndValidity();
        });
        break;
      case AdesaoSaudeEnum.TITULAR:
        this.formData.updateValueAndValidity();
        break;
    }
  }
  resetForm() {
    this.formData.reset();
  }
  adicionarArquivos(fileType: string, event: any) {
    switch (fileType) {
      case 'termoGuardaTutela':
        this.formData.get('termoGuardaTutela.file')?.setValue(event);
        break;
      case 'termoConsentimento':
        this.formData.get('termoConsentimento.file')?.setValue(event);
        break;
      case 'documentoResponsavelLegal':
        this.formData.get('documentoResponsavelLegal.file')?.setValue(event);
        break;
      case 'certidaoNascimento':
        this.formData.get('certidaoNascimento.file')?.setValue(event);
        break;
      case 'certidaoCasamento':
        this.formData.get('certidaoCasamento.file')?.setValue(event);
        break;
      case 'rg':
        this.formData.get('rg.file')?.setValue(event);
        break;
      case 'cpfOuCnh':
        this.formData.get('cpfOuCnh.file')?.setValue(event);
        break;
      case 'dadosBancarios':
        this.formData.get('dadosBancarios.file')?.setValue(event);
        break;
      case 'dadosBancarios':
        this.formData.get('dadosBancarios.file')?.setValue(event);
        break;
      case 'declaracaoVidaConjunta':
        this.formData.get('declaracaoVidaConjunta.file')?.setValue(event);
        break;
      // case 'financialInvoiceMedical':                 
      //   this.formData.get('financialInvoiceMedical.file')?.setValue(event);    
      //   break;
      // case 'financialReceipt': 
      //   this.formData.get('financialReceipt.file')?.setValue(event);    
      //   break;
      // case 'anestheticRecord': 
      //   this.formData.get('anestheticRecord.file')?.setValue(event);    
      //   break;
    }
  }
  removeFile(fileType: string, index: number) {
    const lista: any = this.formData.get(`${fileType}.file`)?.value;
    lista.splice(index, 1);
    this.formData.get(`${fileType}.file`)?.updateValueAndValidity();
  }
  adicionaDocumentos(propertyName: any, setCallBack: any, lista: any): any {
    let form = this.formData.get(`${propertyName}`)?.value as any;
    let newForm = setCallBack;
    for (let i = 0; i < form.length; i++) {
      newForm.patchValue(form[i]);
      lista.push(newForm.value);
      newForm == null;
    }
  }
  sendTo() {
    this.loading = true;
    this.formData.updateValueAndValidity();
    let form = this.formData.value;
    let postData: any = {
      cpfOuCnhDependente: null,
      cnsDependente: null,
      dataNascimentoDependente: null,
      documentos: [],
      email: this.formData.controls.dadosDependente.value.email,
      endereco: {
        bairro: form.endereco?.bairro,
        cep: form.endereco?.cep,
        cidade: form.endereco?.cidade,
        complemento: form.endereco?.complemento,
        endereco: form.endereco?.rua,
        estado: form.endereco?.uf
      },
      nacionalidadeDependente: null,
      nomeDependente: null,
      nomeMaeDependente: null,
      nomePaiDependente: null,
      observacoesDeclaracao: '',
      rgDependente: null,
      sexo: this.formData.controls.dadosDependente.value.sexo,
      telefoneCelular: this.formData.controls.dadosDependente.value.telefoneCelular,
      telefoneResidencial: this.formData.controls.dadosDependente.value.telefoneResidencial,
      termoAdesaoDependente: [],
      tipoPlano: this.formData.value.tipoPlano,
      vinculoIdDependente: null,
    }
    if (this.formData.invalid) {
      this.toast.error('Preencha todos os campos obrigatórios ou verifique os campos inválidos!');
      this.formData.markAllAsTouched();
      this.formData.updateValueAndValidity();
      return;
    }
    if (this.formData.get('cpfOuCnh.doc_type')?.enabled && this.formData.get('cpfOuCnh.file')?.value != null) {
      this.adicionaDocumentos('cpfOuCnh.file', this.criarDocumentoCpf(true), postData.documentos);
    }
    if (this.formData.get('certidaoNascimento.doc_type')?.enabled && this.formData.get('certidaoNascimento.file')?.value != null) {
      this.adicionaDocumentos('certidaoNascimento.file', this.criarDocumentoCertidaoNascimento(true), postData.documentos);
    }
    if (this.formData.get('documentoResponsavelLegal.doc_type')?.enabled && this.formData.get('documentoResponsavelLegal.file')?.value != null) {
      this.adicionaDocumentos('documentoResponsavelLegal.file', this.criarDocumentoResponsavelLegal(true), postData.documentos);
    }
    if (this.formData.get('rg.doc_type')?.enabled && this.formData.get('rg.file')?.value != null) {
      this.adicionaDocumentos('rg.file', this.criarDocumentoRg(true), postData.documentos);
    }
    if (this.formData.get('termoGuardaTutela.doc_type')?.enabled && this.formData.get('termoGuardaTutela.file')?.value != null) {
      this.adicionaDocumentos('termoGuardaTutela.file', this.criarTermoGuardaOuTutelaMenor(true), postData.documentos);
    }
    if (this.formData.get('termoConsentimento.doc_type')?.enabled && this.formData.get('termoConsentimento.file')?.value != null) {
      this.adicionaDocumentos('termoConsentimento.file', this.criarTermoConsentimento(true), postData.documentos);
    }
    if (this.formData.get('dadosDependente.nome')?.enabled) {
      postData.nomeDependente = this.formData.get('dadosDependente.nome')?.value;
      postData.cpfOuCnhDependente = this.formData.get('dadosDependente.cpf')?.value;
      postData.cnsDependente = this.formData.get('dadosDependente.cns')?.value;
      postData.rgDependente = this.formData.get('dadosDependente.rg')?.value;
      postData.nomeMaeDependente = this.formData.get('dadosDependente.nomeMae')?.value;
      postData.nomePaiDependente = this.formData.get('dadosDependente.nomePai')?.value;
      postData.dataNascimentoDependente = this.formData.get('dadosDependente.dataNascimento')?.value;
      postData.vinculoIdDependente = this.formData.get('dadosDependente.vinculo')?.value;
      postData.nacionalidadeDependente = this.formData.get('dadosDependente.nacionalidade')?.value;
    }
    const resultado: any = {};
    for (const chave in postData) {
      if (postData.hasOwnProperty(chave)) {
        const valor = postData[chave];
        if (typeof valor === 'string') {
          resultado[chave] = valor.toUpperCase();
        } else {
          resultado[chave] = valor;
        }
      }
    }
    this.dataService.data = resultado;
    this.dataService.filter = this.formData.value;
    this.router.navigate(['termo-declaracao']);
  }
  aceiteFilhoEnteado(enabled: boolean) {
    return this.formBuilder.group({
      aceiteConfirmaCredenciamento: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      aceiteInclusaoCompanheiro: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      aceiteDespesasCoparticipacao: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      aceiteOmissaoPedido: new FormControl({ value: false, disabled: !enabled }, [Validators.required]),
      aceiteDependenciaEconomica: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      aceiteResponsabilidadeDeclaracoes: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      aceiteDescontoFolhaPagamento: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
    })
  }
  createDependente(enabled: boolean) {
    return this.formBuilder.group({
      nome: new FormControl({ value: null, disabled: !enabled }, [Validators.required, FormValidator.nomeSobrenomeValidator]),
      vinculo: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      dataNascimento: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      cpf: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      rg: new FormControl({ value: null, disabled: !enabled }),
      nomeMae: new FormControl({ value: null, disabled: !enabled }, [Validators.required, FormValidator.nomeSobrenomeValidator]),
      nomePai: new FormControl({ value: null, disabled: !enabled }),
      nacionalidade: new FormControl({ value: 'Brasileiro(a)', disabled: !enabled }, [Validators.required]),
      // responsavel: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      cns: new FormControl({ value: null, disabled: !enabled }),
      telefoneCelular: new FormControl(null, [Validators.required]),
      telefoneResidencial: new FormControl(null),
      email: new FormControl(null, [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
      sexo: new FormControl(null, [Validators.required]),
    })
  }
  criarDocumentoCpf(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Cpf', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  criarDocumentoCertidaoNascimento(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Certidão de Nascimento', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  criarDocumentoCertidaoCasamento(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Certidão de Casamento', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  criarDocumentoBancario(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Cartão ou Extrato Bancário', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  createDeclaracaoVidaConjunta(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Declaracao Vida Conjunta', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  criarDeclaracaoParticipacaoConjunta(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Participação Conjunta de Vida', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  criarDocumentoResponsavelLegal(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Responsável legal', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  criarDocumentoRg(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Rg', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  criarTermoGuardaOuTutelaMenor(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'anestheticRecord', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  criarTermoConsentimento(enabled: boolean) {
    return this.formBuilder.group({
      doc_type: new FormControl({ value: 'Termo de Consentimento', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  pesquisarUf() {
    // this.ibgeService.getCompanyType(this.formData.get('endereco.uf')?.value).subscribe({
    //   next: (res:any)=>{
    //     this.listaCidades = res;
    //   },
    //   error: (err:any)=>{
    //   }
    // });
  }
}
